import ChatRoomLayout from '@/components/layouts/chatroom-layout';
import useSessionEffect from '@/hooks/conversations/use-session-effect';
import { useLayoutStore } from '@/stores/layout-status';
import { parseSessionKey } from '@/utils/session';

export default function SessionMessagesLayout() {
  const id = useLayoutStore((s) => parseSessionKey(s.sessionKey ?? '')[1]);

  useSessionEffect('session', id);

  return <ChatRoomLayout type='session' />;
}
